import { gql } from "@apollo/client";

export const ADD_POST = gql`
  mutation AddPost(
    $author_id: ID!
    $media: [ID]
    $type: String!
    $content: String!
    $location: GeoInputPost
    $location_name: String
    $links: [String]
    $associated_with: [ID]
    $product: ProductInfo
  ) {
    addPost(
      input: {
        author_id: $author_id
        media: $media
        type: $type
        content: $content
        product: $product
        location: $location
        links: $links
        location_name: $location_name
        associated_with: $associated_with
      }
    ) {
      content
    }
  }
`;
export const ADD_TAG = gql`
  mutation AddTag($tag_name: String!) {
    addTag(tag_name: $tag_name)
  }
`;

export const ADD_REACTION = gql`
  mutation AddReaction(
    $reaction_by: ID!
    $reaction_on: ID!
    $reaction_type: ReactionType
  ) {
    addReaction(
      input: {
        reaction_by: $reaction_by
        reaction_on: $reaction_on
        reaction_type: $reaction_type
      }
    )
  }
`;

export const UPDATE_NOTIFICATION = gql`
  mutation UpdateReadNotification($input: updateNotificationInput!) {
    updateReadNotification(input: $input)
  }
`;

export const ADD_SUBSCRIPTION = gql`
  mutation AddSubscription($input: AddSubscriptionInput!) {
    addSubscription(input: $input) {
      response
    }
  }
`;

export const LOGOUT = gql`
  mutation logoutUser {
    logout {
      response
    }
  }
`;
export const ADD_REPORT = gql`
  mutation addReport($reported_entity_id: ID!) {
    addReport(reported_entity_id: $reported_entity_id) {
      report_id
    }
  }
`;

// Messaging mutations
export const START_CHAT = gql`
  mutation StartChat($input: StartChatInput) {
    startChat(input: $input) {
      status
      chat_id
    }
  }
`;

export const SEND_MESSAGE = gql`
  mutation SendMessage($input: SendMessageInput!) {
    sendMessage(input: $input) {
      response
      message_id
      createdAt
    }
  }
`;

export const UPDATE_CHAT_SETTINGS = gql`
  mutation UpdateChatSettings($input: UpdateChatSettingsInput!) {
    updateChatSettings(input: $input) {
      response
    }
  }
`;

export const UPDATE_CHAT = gql`
  mutation UpdateChat($input: UpdateChatInput!) {
    updateChat(input: $input) {
      response
    }
  }
`;

// Post mutations
export const UPDATE_POST = gql`
  mutation updatePost($input: UpdatePostInput!) {
    updatePost(input: $input)
  }
`;

// Delete post (marketplace listing is a post type)
export const DELETE_POST = gql`
  mutation deletePost($input: DeletePostInput!) {
    deletePost(input: $input)
  }
`;

// Comment mutations
export const ADD_COMMENT = gql`
  mutation AddComment($input: AddCommentInput!) {
    addComment(input: $input)
  }
`;

export const UPDATE_COMMENT = gql`
  mutation UpdateComment($input: UpdateCommentInput!) {
    updateComment(input: $input)
  }
`;

// Impression tracking
export const ADD_IMPRESSIONS = gql`
  mutation addImpressions($input: addImpressionInput!) {
    addImpressions(input: $input) {
      response
    }
  }
`;

// Store mutations
export const UPDATE_STORE = gql`
  mutation UpdateStore($input: UpdateStoreInput!) {
    updateStore(input: $input) {
      response
    }
  }
`;

export const CREATE_STORE = gql`
  mutation CreateStore($input: CreateStoreInput!) {
    createStore(input: $input) {
      store_id
    }
  }
`;
export const CREATE_ELECTION = gql`
  mutation CreateElection($input: CreateElectionInput!) {
    createElection(input: $input) {
      election_id
    }
  }
`;

export const ADD_ELECTION_CANDIDATE = gql`
  mutation AddCandidate($input: CreateCandidateInput!) {
    addCandidate(input: $input) {
      response
    }
  }
`;

export const ADD_ELECTION_VOTE = gql`
  mutation AddVote($input: AddVoteInput!) {
    addVote(input: $input) {
      response
    }
  }
`;

export const UPDATE_ELECTION_VOTE = gql`
  mutation UpdateVote($input: UpdateVoteInput!) {
    updateVote(input: $input) {
      response
    }
  }
`;
export const UPDATE_ELECTION_CAMPAIGN = gql`
  mutation UpdateElectionCampaign($input: UpdateElectionInput!) {
    updateElection(input: $input) {
      response
    }
  }
`;
export const UPDATE_ELECTION_CANDIDATE = gql`
  mutation UpdateElectionCandidate($input: UpdateCandidateInput!) {
    updateCandidate(input: $input) {
      response
    }
  }
`;
